
import React, { useState, useEffect, useRef } from 'react';
import {AnimatePresence, motion} from 'framer-motion';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
// import { Link, Element } from 'react-scroll';
import { useUserAPI } from '../../components/useUserAPI';

// import useSound from 'use-sound';
// import se_01 from '../../sound/s01_item_num.mp3';
// import se_08 from '../../sound/s08_se_delay0.mp3';


const motionConfig = {
	initial: {
		y: "100%",
		opacity: 1,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: "100%",
		opacity: 1,
	},
	};
	const noBarcode_cover = {
	initial: {

	},
	animate: {
		opacity: 0.55,
	},
	hidden: {
		opacity: 0,
	},
};


export const NoBarcode = (props) => {

	// const [se01_item_num] = useSound(se_01);
	// const [se08_se] = useSound(se_08);

	const closeModal = (e) => {
		e.stopPropagation();
		props.setShowNoBarcode(false);
		// props.se08_se();
		props.setSoundState("se08_se");
	}

	// const itemClick = (e) => {
	// }

	const [noitemTab, setNoitemTab] = useState("item01")
	const [noitemTabFix, setNoitemTabFix] = useState("")

	const changeTab = nitem => {
		// if(noitemTabFix === ""){
		// 	setNoitemTab(nitem)
		// }
		// props.se08_se();
		props.setSoundState("se08_se");
	}

	const itemBoxRef = useRef(null);


	// const scrollableDivRef = useRef(null);

	let taObj = "";
	const goScroll = (ta) => {
		if (itemBoxRef.current) {
			const targetElement = itemBoxRef.current.querySelector(ta);
			if (targetElement) {
				const targetPosition = targetElement.offsetTop;
				scrollTo(itemBoxRef.current, targetPosition, 800);
				// props.se08_se();
			}
		}
	};

	function easeOutCubic(t) {
		return 1 - Math.pow(1 - t, 3);
	}

	function scrollTo(element, to, duration) {
		const start = element.scrollTop;
		const change = to - start;
		const startTime = performance.now();

		function animateScroll(timestamp) {
			const elapsed = timestamp - startTime;
			const progress = Math.min(elapsed / duration, 1);
			const easeProgress = easeOutCubic(progress);

			element.scrollTop = start + change * easeProgress;

			if (elapsed < duration) {
				requestAnimationFrame(animateScroll);
			}
		}

		requestAnimationFrame(animateScroll);
	}

	useEffect(() => {

		// if(!keyplulistData){
		// 	keyplulistAPI();
		// }

		const itemBox = itemBoxRef.current;
		if (itemBox) {
			const handleScroll = () => {
				// 各セクションの位置を取得
				const itemPositions = {
					item01: document.getElementById('item01').offsetTop,
					item02: document.getElementById('item02').offsetTop - 10,
					item03: document.getElementById('item03').offsetTop - 10,
					item04: document.getElementById('item04').offsetTop - 20,
				};

				// 現在のスクロール位置
				let scrollTop = itemBox.scrollTop;

				// アクティブなセクションを判定
				let activeItem;

				if (scrollTop >= itemPositions.item02 && scrollTop < itemPositions.item03) {
					activeItem = 'item02';
				} else if (scrollTop >= itemPositions.item03 && scrollTop < itemPositions.item04) {
					activeItem = 'item03';
				} else if (scrollTop >= itemPositions.item04) {
					activeItem = 'item04';
				}else {
					activeItem = 'item01';
				}

				// アクティブなセクションに対応するボタンを更新
				const navButtons = document.querySelectorAll('.noBarcode_navBtn');
				navButtons.forEach(btn => {
					btn.classList.remove('is_active');
					if (btn.getAttribute('data-href') === `#${activeItem}`) {
						btn.classList.add('is_active');
					}
				});
				const scobj = document.getElementById('noBarcode_itemBox');
				if (scobj.scrollTop + scobj.clientHeight >= scobj.scrollHeight) {
					console.log("NoBarcode: 下端");
					scobj.scrollTop = scobj.scrollHeight - scobj.clientHeight - 10;
				}
			};

			// スクロールイベントを追加
			itemBox.addEventListener('scroll', handleScroll);

			if(noitemTabFix !== ""){
				console.log("removeEventListener");
				console.log("noitemTabFix: " + noitemTabFix);
				itemBox.removeEventListener('scroll', handleScroll);
				setTimeout(function(){
					var elements = document.getElementsByClassName(noitemTabFix);
					Array.from(elements).forEach(function(element) {
						element.classList.add('is_active');
						element.classList.add('is_fix');
					});
				}, 100);
			}

			// クリーンアップ関数
			return () => {
				itemBox.removeEventListener('scroll', handleScroll);
			};
		}
	}, [props.showNoBarcode,noitemTabFix]);


	const { keyplulistAPI, data: keyplulistData, loading: keyplulistLoading, error: keyplulistError } = useUserAPI();

	useEffect(() => {
		if(props.shoppingStData){
			if(props.shoppingStData.data){
				keyplulistAPI(props.shoppingStData.data.token);
			}
		}
	}, [props.shoppingStData]);

	useEffect(() => {
		if(keyplulistData){
			// console.log("あああ");
			if (keyplulistData.data) { //SUCCESS
				// console.log(keyplulistData.data.keyPluList[0]);
				// props.setShoppingData(changeData);
				// props.setShowItemNum([]);
				if(keyplulistData.data.keyPluList.length === 0){
					props.setKeypluFlg(false);
				}else{
					props.setKeypluFlg(true);
				}
				let filList01 = keyplulistData.data.keyPluList.filter(function(item) {
					return item.categorycode === "1";
				});
				let filList02 = keyplulistData.data.keyPluList.filter(function(item) {
					return item.categorycode === "2";
				});
				let filList03 = keyplulistData.data.keyPluList.filter(function(item) {
					return item.categorycode === "3";
				});
				let filList04 = keyplulistData.data.keyPluList.filter(function(item) {
					return item.categorycode === "4";
				});
				let active_length = 0;
				let active_tab = "";
				if(filList04.length !== 0){
					active_length += 1;
					setNoitemTab("item04");
					active_tab = "t4";
				}
				if(filList03.length !== 0){
					active_length += 1;
					setNoitemTab("item03");
					active_tab = "t3";
				}
				if(filList02.length !== 0){
					active_length += 1;
					setNoitemTab("item02");
					active_tab = "t2";
				}
				if(filList01.length !== 0){
					active_length += 1;
					setNoitemTab("item01");
					active_tab = "t1";
				}
				console.log("active_length: " + active_length);
				console.log("active_tab: " + active_tab);
				if(active_length == 1) {
					setNoitemTabFix(active_tab);
				}
			}else{ //ERROR
				// console.log("ううう");
				console.log(`【keyplulistAPI】 errorCode: ${keyplulistData.errorCode}`);
				console.log(`【keyplulistAPI】 errorMessage: ${keyplulistData.errorMessage}`);
				console.log(`【keyplulistAPI】 isSuccess: ${keyplulistData.isSuccess}`);

				// if(keyplulistData.errorCode === "26"){
				// 	//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				// 	props.setErrFlg(true);
				// 	props.setErr([true,`${keyplulistData.errorCode}`,`;トークン不正;トークン不正のエラー文言。トークン不正のエラー文言。トークン不正のエラー文言。;;;`]);
				// }else if(keyplulistData.errorCode === "27"){
				// 	//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				// 	props.setErrFlg(true);
				// 	props.setErr([true,`${keyplulistData.errorCode}`,`;トークン有効期限切れ;トークン有効期限切れのエラー文言。トークン有効期限切れのエラー文言。トークン有効期限切れのエラー文言。;;;`]);
				// }else{
				// 	props.setErrFlg(true);
				// 	props.setErr([true,`${keyplulistData.errorCode}`,`${keyplulistData.errorMessage}`]);
				// }
				if(props.keypluCount >= 2){
					props.setKeypluFlg(false);
				}else{
					let kn = props.keypluCount + 1;
					props.setKeypluCount(kn);
					keyplulistAPI(props.shoppingStData.data.token);
				}
			}
		}
		if(keyplulistError){
			console.log("keyplulistError");
			console.log(keyplulistError);
			// props.setErrFlg(true);
			// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
			if(props.keypluCount >= 2){
				props.setKeypluFlg(false);
			}else{
				let kn = props.keypluCount + 1;
				props.setKeypluCount(kn);
				keyplulistAPI(props.shoppingStData.data.token);
			}
		}
		// if(keyplulistLoading){
		// 	document.querySelectorAll('.loadingBox01').forEach(function(element) {
		// 		element.classList.add('is_show');
		// 	});
		// 	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
		// 		element.classList.add('is_show');
		// 	});
		// }else{
		// 	document.querySelectorAll('.loadingBox01').forEach(function(element) {
		// 		element.classList.remove('is_show');
		// 	});
		// 	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
		// 		element.classList.remove('is_show');
		// 	});
		// }
	}, [props.shoppingStData,keyplulistData,keyplulistLoading,keyplulistError]);

	// const onSelectNum = (bc,num) => {
	// 	props.setShowItemNum([bc,num]);
	// }

	const { keyplupurchaseAPI, data: keyplupurchaseData, loading: keyplupurchaseLoading, error: keyplupurchaseError } = useUserAPI();

	const onSelectNum = (bcode,bnum) => {
		// e.stopPropagation();
		// props.setShowItemNum(false);
		// const bcode = props.showItemNum[0];
		// props.setShowItemNum([bcode,bnum]);

		onChangeNum(bcode,bnum);
		props.setShowNoBarcode(false);
		// props.se08_se();
		setTimeout(function(){
			props.setSoundState("se01_item_num");
			// se01_item_num();
		}, 300);

		// keyplupurchaseAPI(props.shoppingStData.data.token,bcode,bnum);
	}
	const onChangeNum = (bc,num) => {
		// e.stopPropagation();
		// console.log("bc: "+bc);
		// console.log("num: "+num);
		props.setShowItemNum([bc,num,"add"]);
		// props.se08_se();
		props.setSoundState("se08_se");
	}

	useEffect(() => {
		if(keyplupurchaseData){
			// console.log("あああ");
			if (keyplupurchaseData.data) { //SUCCESS
				// console.log("いいいい");
				props.setShoppingData(keyplupurchaseData);
				props.setShowNoBarcode(false);
				// props.setShowItemNum([]);
			}else{ //ERROR
				console.log(`【keyplupurchaseAPI】 errorCode: ${keyplupurchaseData.errorCode}`);
				console.log(`【keyplupurchaseAPI】 errorMessage: ${keyplupurchaseData.errorMessage}`);
				console.log(`【keyplupurchaseAPI】 isSuccess: ${keyplupurchaseData.isSuccess}`);

				if(keyplupurchaseData.errorCode === "26"){
					//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
					props.setErrFlg(true);
					props.setErr([true,`${keyplupurchaseData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
					// props.setErr([true,`${keyplupurchaseData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
				}else if(keyplupurchaseData.errorCode === "27"){
					//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
					props.setErrFlg(true);
					props.setErr([true,`${keyplupurchaseData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
					// props.setErr([true,`${keyplupurchaseData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
				}else{
					// props.setErrNum(`${keyplupurchaseData.errorCode}`);
					// props.setShowModal(true);
					// props.setErrTxt(`${keyplupurchaseData.errorMessage}`);
					props.setErrFlg(true);
					props.setErr([true,`${keyplupurchaseData.errorCode}`,`${keyplupurchaseData.errorMessage}`]);
				}
			}
		}else{
			// console.log("えええ");
			// console.log("shoppingData: No Data");
		}
		if(keyplupurchaseError){
			console.log("keyplupurchaseError");
			console.log(keyplupurchaseError);
			props.setErrFlg(true);
			props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
			// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
			// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		}
		if(keyplupurchaseLoading){
			document.querySelectorAll('.loadingBox01').forEach(function(element) {
				element.classList.add('is_show');
			});
			document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
				element.classList.add('is_show');
			});
		}else{
			document.querySelectorAll('.loadingBox01').forEach(function(element) {
				element.classList.remove('is_show');
			});
			document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
				element.classList.remove('is_show');
			});
		}
	}, [keyplupurchaseData,keyplupurchaseLoading,keyplupurchaseError]);

	return (

		<AnimatePresence>
		{props.showNoBarcode && (
		<>
			{props.showNoBarcode ? ( // showNoBarcodeがtrueだったらModal表示
				<section id="noBarcode" className={`noBarcode ${props.showNoBarcode === true ? 'is_active' : ''}`}>
				<motion.div className="noBarcode_wrap"
					initial={'initial'}
					animate={'animate'}
					exit={'hidden'}
					variants={motionConfig}
					transition={{duration: 0.3, ease: 'easeOut'}}
				>
				<div className="noBarcode_header">
					<p className="noBarcode_tit">バーコードの無い商品</p>
					<button className="noBarcode_closeBtn" onClick={closeModal}>
						<img src="/images/btn_close01.svg" alt="" width="24" height="24" />
					</button>
					<nav className="noBarcode_nav">

					{
						(() => {
							let filteredList01 = keyplulistData.data.keyPluList.filter(function(item) {
								return item.categorycode === "1";
							});
							if (filteredList01.length === 0) {
							return(
								<button data-href="#item01" className={`noBarcode_navBtn t1 is_disabled`} onClick={(e) => {goScroll('#item01');changeTab("item01");}}>
									<figure className="noBarcode_navBtn_img">
										<img src="/images/icn_item_apple.svg" alt="" width="24" height="24" />
									</figure>
									<span>野菜・果物</span>
								</button>
							)
							} else {
							return (
								<button data-href="#item01" className={`noBarcode_navBtn t1 ${noitemTab === 'item01' ? 'is_active' : ''}`} onClick={(e) => {goScroll('#item01');changeTab("item01");}}>
									<figure className="noBarcode_navBtn_img">
										<img src="/images/icn_item_apple.svg" alt="" width="24" height="24" />
									</figure>
									<span>野菜・果物</span>
								</button>
							)
							}
						})()
					}


					{
						(() => {
							let filteredList02 = keyplulistData.data.keyPluList.filter(function(item) {
								return item.categorycode === "2";
							});
							if (filteredList02.length === 0) {
							return(
								<button data-href="#item02" className={`noBarcode_navBtn t2 is_disabled`} onClick={(e) => {goScroll('#item02');changeTab("item02");}}>
									<figure className="noBarcode_navBtn_img">
										<img src="/images/icn_item_fish.svg" alt="" width="24" height="24" />
									</figure>
									<span>肉・魚</span>
								</button>
							)
							} else {
							return (
								<button data-href="#item02" className={`noBarcode_navBtn t2 ${noitemTab === 'item02' ? 'is_active' : ''}`} onClick={(e) => {goScroll('#item02');changeTab("item02");}}>
									<figure className="noBarcode_navBtn_img">
										<img src="/images/icn_item_fish.svg" alt="" width="24" height="24" />
									</figure>
									<span>肉・魚</span>
								</button>
							)
							}
						})()
					}


					{
						(() => {
							let filteredList03 = keyplulistData.data.keyPluList.filter(function(item) {
								return item.categorycode === "3";
							});
							if (filteredList03.length === 0) {
							return(
								<button data-href="#item03" className={`noBarcode_navBtn t3 is_disabled`} onClick={(e) => {goScroll('#item03');changeTab("item03");}}>
									<figure className="noBarcode_navBtn_img">
										<img src="/images/icn_item_yakitori.svg" alt="" width="24" height="24" />
									</figure>
									<span>惣菜・寿司</span>
								</button>
							)
							} else {
							return (
								<button data-href="#item03" className={`noBarcode_navBtn t3 ${noitemTab === 'item03' ? 'is_active' : ''}`} onClick={(e) => {goScroll('#item03');changeTab("item03");}}>
									<figure className="noBarcode_navBtn_img">
										<img src="/images/icn_item_yakitori.svg" alt="" width="24" height="24" />
									</figure>
									<span>惣菜・寿司</span>
								</button>
							)
							}
						})()
					}


					{
						(() => {
							let filteredList04 = keyplulistData.data.keyPluList.filter(function(item) {
								return item.categorycode === "4";
							});
							if (filteredList04.length === 0) {
							return(
								<button data-href="#item04" className={`noBarcode_navBtn t4 is_disabled`} onClick={(e) => {goScroll('#item04');changeTab("item04");}}>
									<figure className="noBarcode_navBtn_img">
										<img src="/images/icn_item_bag.svg" alt="" width="24" height="24" />
									</figure>
									<span>その他</span>
								</button>
							)
							} else {
							return (
								<button data-href="#item04" className={`noBarcode_navBtn t4 ${noitemTab === 'item04' ? 'is_active' : ''}`} onClick={(e) => {goScroll('#item04');changeTab("item04");}}>
									<figure className="noBarcode_navBtn_img">
										<img src="/images/icn_item_bag.svg" alt="" width="24" height="24" />
									</figure>
									<span>その他</span>
								</button>
							)
							}
						})()
					}
					</nav>
				</div>


				<div id="noBarcode_itemBox" ref={itemBoxRef} className="noBarcode_itemBox t1 is_active is_grid">

				{/* <div className="noBarcode_itemBox_wrap"> */}


				{
					(() => {
						// setTimeout(function(){
						// 	document.querySelector('#noBarcode_itemBox').scrollTop = 0;
						// 	setNoitemTab("item01");
						// }, 100);
					let filteredList01 = keyplulistData.data.keyPluList.filter(function(item) {
						return item.categorycode === "1";
					});

					if(filteredList01.length > 0){
						return (
						<>
						<div id="item01" className="noBarcode_tit">
							<figure className="noBarcode_tit_img">
								<img src="/images/icn_item_apple.svg" alt="" width="24" height="24" />
							</figure>
							<span>野菜・果物</span>
						</div>
						<div className="noBarcode_list">
							{keyplulistData.data.keyPluList.map((item, index) => {
								if(item.categorycode === "1"){
								return (
								<div key={index} data-barcode={item.barCode} className="noBarcode_item" onClick={()=>onSelectNum(item.barCode,1)}>
									<figure className="noBarcode_item_img">
										{/* <img src={item.itemUrl} alt="" width="128" height="128" /> */}
										<img src={item.itemUrl ? item.itemUrl : '/images/noimage.png'} alt="" width="128" height="128"/>
									</figure>
									<p className="noBarcode_item_price">
										<span className="noBarcode_item_price_default"><small>¥</small>{(item.sellPrice).toLocaleString('ja-JP')}</span>
									</p>
									<p className="noBarcode_item_txt is_grid">{item.receiptKanji}</p>
									<div className="noBarcode_item_plus">
										<img src="/images/icn_plus_circle.svg" alt="" width="20" height="20" />
									</div>
								</div>
								)
								}
							})}
						</div>
						</>
						)
					}else{
						return (
						<div id="item01" className=""></div>
						)
					}
					})()
				}


				{
					(() => {
					let filteredList02 = keyplulistData.data.keyPluList.filter(function(item) {
						return item.categorycode === "2";
					});

					if(filteredList02.length > 0){
						return (
						<>
						<div id="item02" className="noBarcode_tit">
							<figure className="noBarcode_tit_img">
								<img src="/images/icn_item_fish.svg" alt="" width="24" height="24" />
							</figure>
							<span>肉・魚</span>
						</div>
						<div className="noBarcode_list">
							{keyplulistData.data.keyPluList.map((item, index) => {
								if(item.categorycode === "2"){
								return (
								<div key={index} data-barcode={item.barCode} className="noBarcode_item" onClick={()=>onSelectNum(item.barCode,1)}>
									<figure className="noBarcode_item_img">
										{/* <img src={item.itemUrl} alt="" width="128" height="128" /> */}
										<img src={item.itemUrl ? item.itemUrl : '/images/noimage.png'} alt="" width="128" height="128"/>
									</figure>
									<p className="noBarcode_item_price">
										<span className="noBarcode_item_price_default"><small>¥</small>{(item.sellPrice).toLocaleString('ja-JP')}</span>
									</p>
									<p className="noBarcode_item_txt is_grid">{item.receiptKanji}</p>
									<div className="noBarcode_item_plus">
										<img src="/images/icn_plus_circle.svg" alt="" width="20" height="20" />
									</div>
								</div>
								)
								}
							})}
						</div>
						</>
						)
					}else{
						return (
						<div id="item02" className=""></div>
						)
					}
					})()
				}


				{
					(() => {
					let filteredList03 = keyplulistData.data.keyPluList.filter(function(item) {
						return item.categorycode === "3";
					});

					if(filteredList03.length > 0){
						return (
						<>
						<div id="item03" className="noBarcode_tit">
							<figure className="noBarcode_tit_img">
								<img src="/images/icn_item_yakitori.svg" alt="" width="24" height="24" />
							</figure>
							<span>惣菜・寿司</span>
						</div>
						<div className="noBarcode_list">
							{keyplulistData.data.keyPluList.map((item, index) => {
								if(item.categorycode === "3"){
								return (
								<div key={index} data-barcode={item.barCode} className="noBarcode_item" onClick={()=>onSelectNum(item.barCode,1)}>
									<figure className="noBarcode_item_img">
										{/* <img src={item.itemUrl} alt="" width="128" height="128" /> */}
										<img src={item.itemUrl ? item.itemUrl : '/images/noimage.png'} alt="" width="128" height="128"/>
									</figure>
									<p className="noBarcode_item_price">
										<span className="noBarcode_item_price_default"><small>¥</small>{(item.sellPrice).toLocaleString('ja-JP')}</span>
									</p>
									<p className="noBarcode_item_txt is_grid">{item.receiptKanji}</p>
									<div className="noBarcode_item_plus">
										<img src="/images/icn_plus_circle.svg" alt="" width="20" height="20" />
									</div>
								</div>
								)
								}
							})}
						</div>
						</>
						)
					}else{
						return (
						<div id="item03" className=""></div>
						)
					}
					})()
				}


				{
					(() => {
					let filteredList04 = keyplulistData.data.keyPluList.filter(function(item) {
						return item.categorycode === "4";
					});

					if(filteredList04.length > 0){
						return (
							<>
							<div id="item04" className="noBarcode_tit">
							<figure className="noBarcode_tit_img">
								<img src="/images/icn_item_bag.svg" alt="" width="24" height="24" />
							</figure>
							<span>その他</span>
						</div>
						<div className="noBarcode_list">
							{keyplulistData.data.keyPluList.map((item, index) => {
								if(item.categorycode === "4"){
								return (
								<div key={index} data-barcode={item.barCode} className="noBarcode_item" onClick={()=>onSelectNum(item.barCode,1)}>
									<figure className="noBarcode_item_img">
										{/* <img src={item.itemUrl} alt="" width="128" height="128" /> */}
										<img src={item.itemUrl ? item.itemUrl : '/images/noimage.png'} alt="" width="128" height="128"/>
									</figure>
									<p className="noBarcode_item_price">
										<span className="noBarcode_item_price_default"><small>¥</small>{(item.sellPrice).toLocaleString('ja-JP')}</span>
									</p>
									<p className="noBarcode_item_txt is_grid">{item.receiptKanji}</p>
									<div className="noBarcode_item_plus">
										<img src="/images/icn_plus_circle.svg" alt="" width="20" height="20" />
									</div>
								</div>
								)
								}
							})}
						</div>
						</>
						)
					}else{
						return (
						<div id="item04" className=""></div>
						)
					}
					})()
				}

				{/* </div> */}
				</div>
					</motion.div>
				<motion.div className="noBarcode_cover" onClick={closeModal}
					initial={'initial'}
					animate={'animate'}
					exit={'hidden'}
					variants={noBarcode_cover}
					transition={{duration: 0.3, ease: 'linear'}}
				></motion.div>
				</section>

			) : ( // showModalがfalseの場合はModal非表示
				<></>
			)}
		</>
		)}
		</AnimatePresence>
	)
}
